module.exports = __webpack_public_path__ + "img/icon_sportMenu_boxing.529ed558.svg";